import { render, staticRenderFns } from "./Economy.vue?vue&type=template&id=d4f26f00&scoped=true&"
import script from "./Economy.vue?vue&type=script&lang=js&"
export * from "./Economy.vue?vue&type=script&lang=js&"
import style0 from "./Economy.vue?vue&type=style&index=0&id=d4f26f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f26f00",
  null
  
)

export default component.exports